import moment from 'moment'
import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default Vue.extend({
    components: {
        Confirm
    },

    data: () => ({
        location : '',
        profile_details:{},
        job_details : [],
        opportunities : '',
        prfileImg : '',
        dataLoading:false,
        shwdata : true
    }),
    created(){
        this.profileall_details();
    },
  
    methods:{
        async profileall_details(){
            this.dataLoading=true;
            let token =  localStorage.getItem("jwt");
            let userId = localStorage.getItem("userId");
            if (token && userId) { 
                const auth = {
                    headers: {authorization: token} 
                }  
                let recruiter_details = await this.$http.get('/job/fetchRecruiterDetails/'+userId,auth);
               
                if(recruiter_details.status===200 && recruiter_details.data.message === "Recruiter found"){
                    this.profile_details = recruiter_details.data.recruiter;
                 
                    if(recruiter_details.data.recruiter.unlisted_opportunities!=''){
                   
                        this.opportunities = recruiter_details.data.recruiter.opportunities.concat(recruiter_details.data.recruiter.unlisted_opportunities);
                    }
                    else { 
                        this.opportunities = recruiter_details.data.recruiter.opportunities;
                    }
                }
                let resp1 = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
               
                if(resp1.status===200 && resp1.data.message === "Jobs found"){
                    this.job_details= resp1.data.jobs;
                    console.log(" this.job_details", this.job_details);
                    this.dataLoading = false;
                    this.shwdata = this.job_details.length==0?false:true
                    for (let i = 0; i < this.job_details.length; i++) {
                        for (let j = 0; j < this.job_details[i].exam_dates.length; j++) {
                            var day = moment.unix(this.job_details[i].exam_dates[j]);
                            this.job_details[i].exam_dates[j] = day.format('MMMM Do YYYY, h:mm a')
                        }
                    }
                }
                 
            }
        },
        updatePage(){
            localStorage.removeItem('meassage')
            this.$router.push({ name: 'profile_update'})
        },

        backPage() {
            window.history.back()
        },

        candidate_invite(id){
            console.log("id",id);
            this.$router.push({ name: 'recomended_talent', params: { id: id } })
        },
        
        async job_delete(id){
            // try {
            //     // let jId = parseInt(id);
            //     if (await this.$refs.confirm.open('Remove Job', 'Are you sure?', {color: 'black'})) {

            //         let token = localStorage.getItem("jwt");
            //         let userId = localStorage.getItem("userId");
            //         if (token && userId) { 
            //             const auth = {
            //                 headers: {authorization: token} 
            //             }  
            //             let res = await this.$http.post('/job/removeJob',{
            //                 job_id: id,
            //                 user_id: userId
            //             },auth);
            //             if (res.status === 200 && res.data.message === "Job removed successfully") {
            //                 this.snackbar = true;
            //                 this.showMessage = 'Removed Successfully.'
            //                 this.profileall_details();
            //             } 
            //         }
            //     }
            // }catch(error){}
            try {
                //  await this.alertMsg('Remove Job','info','Are you sure?',id)
                 this.$swal({
                  title: 'Remove Job',
                  text: 'Are you sure?',
                  icon: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Confirm',
                  cancelButtonText:'Cancel',
                  customClass: 'swal-title-jobapplication'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.delete_job(id);
                }
               
              })
      
              }catch(error){}
        },

        async delete_job(id){
                   let token = localStorage.getItem("jwt");
                    let userId = localStorage.getItem("userId");
                    if (token && userId) { 
                        const auth = {
                            headers: {authorization: token} 
                        }  
                        let res = await this.$http.post('/job/removeJob',{
                            job_id: id,
                            user_id: userId
                        },auth);
                        if (res.status === 200 && res.data.message === "Job removed successfully") {
                            this.snackbar = true;
                            this.showMessage = 'Removed Successfully.'
                            this.profileall_details();
                        } 
                    }
        }
    }
})